import {TextField} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import 'Agent/AgentForms/Marketing/components/MarketingViewCart.sass';
import 'Agent/AgentForms/Marketing/components/SearchForm.sass';
import {Async, fromResult, toEither} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {EmptyCostCenter, getCostCenters, onChangeCostCenter, RequiredCheckoutCartFields} from '../ducks/Marketing';
import {FormCostCenterDto} from '../models/Marketing';

export type CostCenterProps = {
  dispatchChange: () => void;
  setHandler: (e: any, costCenter?: string) => void;
};

export const getCostCenterOptions = (costCenters: Async<FormCostCenterDto[]>) => {
  const costCenterList: FormCostCenterDto[] | undefined = pipe(
    toEither(costCenters),
    E.map(fromResult),
    E.fold(
      () => undefined,
      value => value.Data
    )
  );

  return costCenterList !== undefined ? costCenterList : [];
};

const CostCenterInput = (props: CostCenterProps) => {
  const dispatch = useDispatch();
  const {missingRequiredFields, costCenters, selectedCostCenter} = useSelector(
    (state: ReducerState) => state.marketing
  );
  const costCenterOptions = getCostCenterOptions(costCenters);

  useEffect(() => {
    if (costCenters.key !== 'Loaded') {
      dispatch(getCostCenters());
    }
  }, []);

  return (
    <Autocomplete
      options={costCenterOptions}
      getOptionLabel={option =>
        option.costCenter && option.costCenterDescription
          ? `${option.costCenter} - ${option.costCenterDescription}`
          : ''
      }
      size="small"
      value={selectedCostCenter}
      onChange={onChangeCostCenter(dispatch, props)}
      onBlur={e => props.dispatchChange()}
      renderInput={params => (
        <TextField
          {...params}
          variant="outlined"
          name="costCenter"
          label={
            missingRequiredFields.includes(RequiredCheckoutCartFields.COST_CENTER) &&
            selectedCostCenter === EmptyCostCenter
              ? 'Cost Center is required'
              : 'Enter Cost Center'
          }
          error={
            missingRequiredFields.includes(RequiredCheckoutCartFields.COST_CENTER) &&
            selectedCostCenter === EmptyCostCenter
          }
        />
      )}
    />
  );
};

export default CostCenterInput;
